import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import Logo from "../assets/logo.svg";
import { Facebook, Instagram, Twitter } from "lucide-react";

export default function Footer() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <footer className="bg-gray-900 mt-auto">
      <div className="px-4 sm:px-6 md:px-8 lg:px-16 xl:px-24 py-8 md:py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Logo and Description */}
          <div className="col-span-1 md:col-span-2">
            <img
              src={Logo}
              alt="Kaman Logo"
              className="w-auto h-10 md:h-12 mb-4 cursor-pointer "
              onClick={() => navigate("/")}
            />
            <p className="text-gray-300 text-sm md:text-base max-w-md">
              {t("footer.description")}
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-semibold text-white mb-4">
              {t("footer.quick_links")}
            </h3>
            <ul className="space-y-2">
              <li>
                <a
                  onClick={() => navigate("/")}
                  className="text-gray-300 hover:text-primary cursor-pointer transition-colors text-sm md:text-base"
                >
                  {t("footer.home")}
                </a>
              </li>
              <li>
                <a
                  onClick={() => navigate("/restaurants")}
                  className="text-gray-300 hover:text-primary cursor-pointer transition-colors text-sm md:text-base"
                >
                  {t("footer.restaurants")}
                </a>
              </li>
              <li>
                <a
                  onClick={() => navigate("/popular-items")}
                  className="text-gray-300 hover:text-primary cursor-pointer transition-colors text-sm md:text-base"
                >
                  {t("footer.popular_items")}
                </a>
              </li>
              <li>
                <a
                  onClick={() => navigate("/new-items")}
                  className="text-gray-300 hover:text-primary cursor-pointer transition-colors text-sm md:text-base"
                >
                  {t("footer.new_items")}
                </a>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h3 className="font-semibold text-white mb-4">
              {t("footer.legal")}
            </h3>
            <ul className="space-y-2">
              <li>
                <a
                  onClick={() => navigate("/privacy-policy")}
                  className="text-gray-300 hover:text-primary cursor-pointer transition-colors text-sm md:text-base"
                >
                  {t("footer.privacy_policy")}
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-700 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-gray-400 text-sm text-center md:text-left">
            {t("footer.copyright", { year: new Date().getFullYear() })}
          </p>

          {/* Social Links */}
          {/* <div className="flex items-center gap-4">
            <a
              href="https://facebook.com"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-300 hover:text-primary transition-colors"
            >
              <Facebook className="w-5 h-5" />
            </a>
            <a
              href="https://instagram.com"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-300 hover:text-primary transition-colors"
            >
              <Instagram className="w-5 h-5" />
            </a>
            <a
              href="https://twitter.com"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-300 hover:text-primary transition-colors"
            >
              <Twitter className="w-5 h-5" />
            </a>
          </div> */}
        </div>
      </div>
    </footer>
  );
}
